import { Page } from '@/core/architecture'

import { OfficialInformationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * OfficialInformation Page
 * Implemented as a practical sample.
 */
export const OfficialInformation: Page = () => {
  const { state, actions } = useViewModel()

  return <OfficialInformationTemplate state={state} {...actions} />
}
